import { TCurrency } from "./types"

type T = {
	currenciesWithFormat: { [currency: string]: TCurrency }
}

export const moneyConfig = {
	defaultCurrency: "INR",
	currenciesWithFormat: {} as T["currenciesWithFormat"],
	showSolidus: false,
}

/**
 * Configure available currencies for money formatting.
 * This should be called when currency data is loaded.
 */
export function configureCurrencies(currencies: Array<TCurrency>) {
	// Convert array to dictionary for O(1) lookup performance
	moneyConfig.currenciesWithFormat = currencies.reduce(
		(acc, currency) => {
			acc[currency.currency] = currency
			return acc
		},
		{} as T["currenciesWithFormat"]
	)
}

/**
 * Configure whether to show solidus (/-) after money amounts.
 * This should be called when configuration data is loaded.
 */
export function configureSolidus(solidus?: boolean | "0" | "1") {
	moneyConfig.showSolidus = solidus === true || solidus === "1"
}

/**
 * Get the configured solidus setting
 */
export function getSolidusSetting(): boolean {
	return moneyConfig.showSolidus
}

/**
 * Get the format for a currency from tenant configuration
 */
export function getCurrencyFormat(currencyCode: string): string {
	const config = moneyConfig.currenciesWithFormat[currencyCode]
	return config?.format || "en_IN"
}
